<div class="do-more-games-container">
    <div class="content-wrapper">
        <div class="image-section">
            <img
                    src="assets/img/hero-about/AdobeStock_318171796@2x.png"
                    alt="Gamer with controller"
                    class="gamer-image"
            />
        </div>

        <div class="text-section">
            <h1 class="heading">Do more games</h1>

            <p class="description">
                At YoGamez Pro, we believe gaming is more than just play—
                it's a lifestyle, a community, and a gateway to endless
                possibilities. Built for gamers, by gamers, YoGamez Pro is your
                ultimate hub for immersive gaming experiences, competitive
                challenges, and entertainment that pushes boundaries.
            </p>

            <button class="join-btn" (click)="onJoinNow()">
                JOIN NOW
            </button>
        </div>
    </div>
</div>
